export const clickableHeader = { cursor: 'pointer', userSelect: 'none' } as const
